import { cn, Text } from '@viapeople/components'
import type { AverageCustomProps, ComponentProps } from './types'
import { getLabelVariant } from './utils'

type FormsAverageProps = ComponentProps & {
	value?: number | null
}

export function FormsAverage({ component, value }: FormsAverageProps) {
	const { label, labelColor, labelSize, labelWeight, prefix, suffix, decimals } = component.custom as AverageCustomProps

	// Clamp decimals to valid range (0-20) to prevent toFixed() RangeError
	const safeDecimals = Math.max(0, Math.min(20, decimals ?? 2))
	const displayValue = value !== null && value !== undefined ? value.toFixed(safeDecimals) : '—'

	return (
		<div className='flex flex-col gap-1'>
			{label && (
				<Text
					className={cn(labelWeight === 'hidden' && 'hidden')}
					variant={getLabelVariant(labelSize, 'xsmall')}
					style={{ color: labelColor }}
					weight={(labelWeight !== 'hidden' && labelWeight) || null}>
					{label}
				</Text>
			)}
			<div className='flex items-center gap-2 self-start' data-testid='forms-average-value'>
				{prefix && <Text variant='small'>{prefix}</Text>}
				<div className='bg-neutral-50 border border-neutral-200 rounded-md px-4 py-2 min-w-[100px]'>
					<Text variant='small' weight='semibold'>
						{displayValue}
					</Text>
				</div>
				{suffix && <Text variant='small'>{suffix}</Text>}
			</div>
		</div>
	)
}
